import React, { lazy, Suspense } from 'react';
import CallTopBar from './CallTopBar';
import { injectIntl } from 'react-intl';
import { Peer } from 'peerjs';
import { connect } from 'react-redux';
import TranscriptionModal from './TranscriptionModal';
import RatingPopup from './RatingPopup';
import { Prompt } from 'react-router-dom';
import CallComponent from '../../InterpreterCall/ui';
import { setReasonOfCall } from '../../InterpreterCall/Action';
import UserCallComponent from '../../UserCall/ui';
import { Button, Modal } from 'react-bootstrap';
import io from 'socket.io-client';
import { checkInterpretersAvailable, leaveQueue, endSTAI2Call } from './stai2Service';
import * as moment from 'moment';
import { toAbsoluteUrl } from '../../../../_ens/_helpers';
import * as videoCall from '../../../../redux/videoCallReducer';
import { bindActionCreators } from 'redux';

import * as Yup from 'yup';
import { Form, Formik } from 'formik';
import Select from 'react-select';
import { WebSocketContext } from '../../../../_ens/layout/components/Layout';
import { APILINK, HOST, ICESERVERS } from '../../../../config/config';
import { isInterpreter } from '../../../servics/CommonFunctions';
import { isIpad } from '../../../../_ens/_helpers';
import ConfirmationDialog from './IpadConfirmationDialog';
import { getAdminSettings } from '../../../modules/Admin/AdminActions';
import { getAllServiceTypes } from '../../../services/generic.service';
import {
  getWaitingUserCount,
  getWaitingUsers,
  createSTAI2Room,
  getSTAI2RoomByPeer
} from './stai2Service';
import TldrawBoard from '../../../pages/Blackboard/TldrawBoard';
import VideoCallTranscriptions from '../../../pages/VideoCall/VideoCallTranscriptions';
import './VideoCallSTAI2.scss';
import { getProjectById } from '../../../services/projects.service';

const STAI2VideoRoomList = lazy(() => import('../components/STAI2VideoRoomList'));


// const titleOptions = (await getAllServiceTypes()).data;
// Fix: await at top level might cause issues in some bundlers, handled inside component or moved
let titleOptions = [];
getAllServiceTypes().then((res) => {
  if (res && res.data) titleOptions = res.data;
});

const CallStates = Object.freeze({
  CONNECTING: 'connecting',
  WAITING: 'waiting',
  STARTING_CALL: 'starting_call',
  CONNECTED: 'connected',
  READY_TO_ACCEPT: 'ready_to_accept',
  CALL_ENDED: 'call_ended'
});

class VideoCallPage extends React.Component {
  static contextType = WebSocketContext;
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      current_state: CallStates.CONNECTING,
      peer: null,
      peer_id: null,
      transcribeAudio: false,
      waiting_users: null,
      from_user: null,
      clientId: null,
      interpreterId: null,
      userId: null,
      current_call_peer_id: null,
      videoContainer: [],
      showDisconnected: false,
      audioEnabled: true,
      isFullScreen: false,
      showList: false,
      videoCallToggle: false,
      interpreter_available: null,
      alertShow: false,
      interpreter_motive_modal: false,
      interpreter_motive_modal_initial_values: {
        title: ''
      },
      buttonEventDisable: false,
      senderName: '',
      receiverName: '',
      transcription: '',
      currentView: 'chat',
      showChat: false,
      showPermissionDialog: false,
      openDialog: false,
      localStream: null,
      showBlackboard: false,
      // STAI2 specific fields
      roomId: null, // Database room ID for chat and whiteboard sync
      sessionToken: null,
      guestName: null,
      isGuest: false,
      isSafari: this.detectSafari(),
      isIOS: this.detectIOS(),
      showMobileChat: false, // Per mostrare/nascondere chat su mobile
      // Posizione del video flottante (per drag su mobile)
      floatingVideoPosition: { x: null, y: null },
      // Rating popup state
      showRatingPopup: false,
      showThankYouPopup: false,
      isDraggingVideo: false
    };
    this.socket = null;
    this.dragStartPos = { x: 0, y: 0 };
    this.videoStartPos = { x: 0, y: 0 };
    this.interval = null;
    this.projectId = props.location?.state?.id || null;
    this.project = null;
    this.mediaStreamPromise = null;
  }

  detectSafari = () => {
    const ua = navigator.userAgent.toLowerCase();
    return ua.indexOf('safari') !== -1 && ua.indexOf('chrome') === -1;
  };

  detectIOS = () => {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  };

  handleBlackboard = () => {
    this.setState((prevState) => ({
      showBlackboard: !prevState.showBlackboard,
      // Reset posizione quando si chiude la blackboard
      floatingVideoPosition: !prevState.showBlackboard
        ? prevState.floatingVideoPosition
        : { x: null, y: null }
    }));
  };

  toggleMobileChat = () => {
    this.setState((prevState) => ({
      showMobileChat: !prevState.showMobileChat,
      // Reset posizione quando si chiude la chat
      floatingVideoPosition: !prevState.showMobileChat
        ? prevState.floatingVideoPosition
        : { x: null, y: null }
    }));
  };

  // Gestione drag del video flottante
  handleVideoTouchStart = (e) => {
    if (!this.state.showMobileChat && !this.state.showBlackboard) return;
    const touch = e.touches[0];
    this.dragStartPos = { x: touch.clientX, y: touch.clientY };
    const videoEl = e.currentTarget;
    const rect = videoEl.getBoundingClientRect();
    this.videoStartPos = { x: rect.left, y: rect.top };
    this.setState({ isDraggingVideo: true });
  };

  handleVideoTouchMove = (e) => {
    if (!this.state.isDraggingVideo || (!this.state.showMobileChat && !this.state.showBlackboard))
      return;
    e.preventDefault();
    const touch = e.touches[0];
    const deltaX = touch.clientX - this.dragStartPos.x;
    const deltaY = touch.clientY - this.dragStartPos.y;

    // Calcola nuova posizione con limiti dello schermo
    const newX = Math.max(0, Math.min(window.innerWidth - 130, this.videoStartPos.x + deltaX));
    const newY = Math.max(0, Math.min(window.innerHeight - 170, this.videoStartPos.y + deltaY));

    this.setState({
      floatingVideoPosition: { x: newX, y: newY }
    });
  };

  handleVideoTouchEnd = () => {
    this.setState({ isDraggingVideo: false });
  };

  waitForSocket = async (maxWaitTime = 15000) => {
    // For STAI2, we create our own socket, so check if we already have one
    if (this.socket && this.socket.connected) {
      return Promise.resolve(true);
    }
    const startTime = Date.now();

    return new Promise((resolve) => {
      const checkSocket = () => {
        // First check our own socket
        if (this.socket && this.socket.connected) {
          resolve(true);
          return;
        }

        // Try context as fallback
        const contextSocket = this.context?.socket || this.context || this.props.socket;
        if (contextSocket && contextSocket.connected) {
          this.socket = contextSocket;
          resolve(true);
          return;
        }

        if (Date.now() - startTime > maxWaitTime) {
          // Try to create socket directly as fallback
          this.initializeSocketDirectly().then(() => {
            resolve(!!this.socket);
          });
        } else {
          // Check again in 500ms
          setTimeout(checkSocket, 500);
        }
      };

      checkSocket();
    });
  };

  checkConnectionStatus = () => {
    // Skip check if component just mounted (give time for connections to establish)
    const componentAge = Date.now() - (this.componentMountTime || Date.now());
    if (componentAge < 5000) {
      // Skip check for first 5 seconds
      return;
    }

    // Check socket with null safety - only warn if we expect to have a socket
    if (this.socket && (!this.socket.connected || this.socket.readyState === WebSocket.CLOSED)) {
      // Connection lost - could show user notification here
    }

    // Check peer with null safety
    if (this.state.peer && this.state.peer.disconnected) {
      // Peer disconnected - could show user notification here
    }
  };

  handleVisibilityChange = () => {
    if (document.hidden) {
      // App andata in background
      console.log('📱 STAI2 - App backgrounded');
    } else {
      // App tornata in foreground
      console.log('📱 STAI2 - App foregrounded, checking streams');

      // Su iOS, a volte è necessario forzare il refresh dei video elements
      if (this.state.isIOS || this.state.isSafari) {
        Object.keys(this.state.videoContainer).forEach((id) => {
          const video = document.getElementById(id);
          if (video && video.paused && !video.ended) {
            console.log('📱 STAI2 - Attempting to resume paused video on iOS');
            video.play().catch((e) => console.log('Resume failed:', e));
          }
        });
      }
    }
  };

  async componentDidMount() {
    // Aggiungi listener per visibility change (fix freeze su iOS cambio tab)
    document.addEventListener('visibilitychange', this.handleVisibilityChange);

    const urlParams = new URLSearchParams(window.location.search);
    const sessionTokenFromUrl = urlParams.get('sessionToken');
    const guestNameFromUrl = urlParams.get('guestName');
    const peerIdFromUrl = urlParams.get('peer_id');
    const projectIdFromUrl = urlParams.get('projectId');
    // Se l'URL non porta projectId non azzerare quello arrivato da location.state:
    // con projectId null la pagina finirebbe a registrarsi sulla coda del progetto 1.
    this.projectId = projectIdFromUrl || this.projectId || null;
    // Track component mount time for connection status checks
    this.componentMountTime = Date.now();

    document.body.classList.add('aside-minimize');
    try {
      // Il progetto serve solo a decidere se mostrare il popup rating a fine chiamata:
      // se fallisce si prosegue senza, non deve impedire l'init di peer e socket.
      try {
        const response = await getProjectById(this.projectId);
        this.project = response.data || response;
      } catch (projectError) {
        console.error('⚠️ STAI2 - Impossibile caricare il progetto:', projectError);
        this.project = null;
      }

      if (isIpad() && isInterpreter()) this.setState({ showPermissionDialog: true });

      getAdminSettings().then(() => {
        //TODO avviso di indisponibilità del servizio per le ore di chiusura
      });

      // ✅ STAI2 Socket initialization
      // Per utenti autenticati (User/Interpreter): crea sempre un socket dedicato STAI2
      // Per guest: usa initializeGuestSocket (con sessionToken)
      const isAuthenticatedUser = this.props.auth && this.props.auth.user && !sessionTokenFromUrl;
      if (isAuthenticatedUser) {
        // Socket dedicato per autenticati - non usare context (CSB) per evitare conflitti
        // L'initializeSocketDirectly verrà chiamato nel blocco auth qui sotto
        console.log('🔌 STAI2 - Authenticated user, will create dedicated socket');
      } else if (!this.context) {
        setTimeout(async () => {
          const socketAvailable = await this.waitForSocket(15000);
          if (socketAvailable) {
            this.initializeSTAI2Socket();
          }
        }, 1000);
      } else {
        // Guest/no-auth: usa context solo come fallback
        this.socket = this.context;
        this.initializeSTAI2Socket();
      }

      // Check for guest parameters in URL and localStorage

      // 🔧 DIRECT CALL: If guest has peer_id in URL, it means call was already initiated by interpreter
      if (peerIdFromUrl && sessionTokenFromUrl) {
        console.log(
          '📞 STAI2 - GUEST: Will wait for interpreter to call peer:',
          peerIdFromUrl,
          ' for projectID: ',
          this.projectId
        );
      }

      // Check for stored call data from localStorage (from waiting page)
      const storedCallData = localStorage.getItem('stai2CallData');
      let callData = null;
      if (storedCallData) {
        try {
          callData = JSON.parse(storedCallData);
          console.log('📱 STAI2 - Found stored call data:', callData);
        } catch (e) {
          console.error('📱 STAI2 - Error parsing stored call data:', e);
        }
      }

      // Guest access detected
      if (peerIdFromUrl || sessionTokenFromUrl || (callData && callData.isGuest)) {
        console.log('👤 STAI2 - Guest access detected, setting up guest flow');

        const guestSessionToken = sessionTokenFromUrl || callData?.sessionToken;
        const guestName = guestNameFromUrl || callData?.guestName || 'Guest User';
        const peerId = peerIdFromUrl || callData?.peer_id;
        const isWaiting = urlParams.get('waiting') === 'true' || callData?.isWaiting;

        // Store guest data in component state
        this.setState({
          isGuest: true,
          sessionToken: guestSessionToken,
          guestName: guestName,
          current_call_peer_id: peerId,
          receiverName: callData?.interpreterName || 'Interpreter',
          isGuestWaiting: isWaiting, // Flag for waiting mode
          current_state: isWaiting ? CallStates.WAITING : CallStates.STARTING_CALL
        });

        console.log(
          '👤 STAI2 - Guest mode:',
          isWaiting ? 'WAITING for interpreter' : 'STARTING CALL'
        );

        // Clear stored data after use
        if (storedCallData) {
          localStorage.removeItem('stai2CallData');
        }
      }

      const sessionToken = sessionTokenFromUrl;
      const guestName = guestNameFromUrl;

      const temp_peer = await this.initializePeerConnection();

      // Handle guest users without authentication
      if (sessionToken || this.state.isGuest) {
        const guestSessionToken = sessionToken || this.state.sessionToken;
        const finalGuestName = guestName || this.state.guestName || 'Guest User';

        this.setState(
          {
            sessionToken: guestSessionToken,
            guestName: finalGuestName,
            isGuest: true,
            peer: temp_peer,
            senderName: finalGuestName,
            projectId: this.projectId, // STAI2 project ID
            current_state: CallStates.WAITING, // Guest waiting state
            showNoInterpreterWarning: false
          },
          async () => {
            this.initializePeersEvents();

            // Initialize guest socket instead of regular socket
            if (guestSessionToken) {
              console.log('👤 STAI2 - Initializing guest socket');
              await this.initializeGuestSocket(guestSessionToken);

              // Start checking interpreter availability using API
              console.log('👤 STAI2 - Guest ready, starting API-based interpreter checks');

              // Initial check
              setTimeout(() => {
                this.checkInterpreterAvailability();

                // Check every 15 seconds using API (less frequent than socket events)
                this.interpreterCheckInterval = setInterval(() => {
                  if (this.state.isGuest && this.state.current_state === CallStates.WAITING) {
                    this.checkInterpreterAvailability();
                  }
                }, 15000);
              }, 3000);
            }
          }
        );
      }
      // Handle guest in waiting mode (new simplified flow)
      else if (this.state.isGuestWaiting && this.state.sessionToken) {
        console.log('👤 STAI2 - Guest in waiting mode, initializing socket');
        await this.initializeGuestSocket(this.state.sessionToken);
      }
      // Handle authenticated users (interpreters/users)
      else if (this.props.auth && this.props.auth.user) {
        const { firstName, lastName } = this.props.auth.user;

        this.setState(
          {
            peer: temp_peer,
            senderName: `${firstName} ${lastName}`,
            projectId: this.projectId // STAI2 project ID
          },
          async () => {
            this.initializePeersEvents();
            this.setState({ userId: this.props.auth.user.id });
            if (this.props.auth.user.role === 'User') {
              this.setState({ clientId: this.props.auth.user.id });
              // Crea socket STAI2 dedicato per l'utente registrato (come l'interprete)
              if (!this.socket) {
                console.log('🔌 STAI2 - Creating dedicated socket for registered User');
                await this.initializeSocketDirectly();
              }
            } else {
              this.setState({ interpreterId: this.props.auth.user.id });

              // Wait for socket to be available before setting up interpreter functionality
              if (!this.socket) {
                console.log('🔌 STAI2 - Creating socket directly (not waiting for Layout)');
                await this.initializeSocketDirectly();
              }

              // Only interpreters check for waiting users
              this.checkForWaitingUsers();

              this.interval = setInterval(async () => {
                await this.checkForWaitingUsers();
              }, 5000);
            }
          }
        );
      }
      // Handle guest users with sessionToken
      else if (this.state.sessionToken || this.state.isGuest) {
        console.log('👤 STAI2 - Guest initialization in componentDidMount');
        // Guest initialization is already handled in constructor/componentDidMount setup
        // Just ensure peer is set up correctly
        this.setState(
          {
            peer: temp_peer,
            senderName: this.state.guestName || 'Guest User',
            projectId: this.projectId // STAI2 project ID
          },
          () => {
            this.initializePeersEvents();
          }
        );
      } else {
        throw new Error('No authentication found and no session token provided');
      }
      window.addEventListener('online', this.handleConnectionChange);
      window.addEventListener('offline', this.handleConnectionChange);
    } catch (error) {
      console.error('🚨 STAI2 - Error in componentDidMount:', error);

      // Don't show alert for guest users, just log and continue with minimal setup
      if (this.state.isGuest) {
        console.warn('⚠️ STAI2 - Guest mode error, continuing with minimal setup');
        // Try minimal guest setup
        try {
          const peerOpts = {
            host: HOST,
            secure: true,
            debug: 3,
            config: {
              iceServers: ICESERVERS
            }
          };

          if (process.env.NODE_ENV === 'production') {
            peerOpts.port = 9000;
          }

          const temp_peer = new Peer(`${Math.floor(100000 + Math.random() * 900000)}`, peerOpts);
          this.setState({ peer: temp_peer });
        } catch (peerError) {
          console.error('❌ STAI2 - Even minimal peer setup failed:', peerError);
        }
      } else {
        console.error('❌ STAI2 - Critical error for authenticated user:', error);
        alert(
          'Si è verificato un errore durante il caricamento della pagina. Ricarica la pagina per riprovare.'
        );
        // For now, don't auto-reload to prevent infinite loops
        // window.location.reload();
      }
    }
    this.checkConnectionStatus();
    this.connectionInterval = setInterval(() => {
      this.checkConnectionStatus();
    }, 300000);
  }

  addUnloadPrompt() {
    window.addEventListener('beforeunload', this.keepOnPage);
    window.addEventListener('unload', this.handleEndConcert);
  }

  removeUnloadPrompt() {
    window.removeEventListener('beforeunload', this.keepOnPage);
    window.removeEventListener('unload', this.handleEndConcert);
  }

  //  try for browser tab close handle in ongoing call
  keepOnPage = (e) => {
    e.preventDefault();
    // var message = 'You want to leave this page?';

    e.returnValue = '';
    // return message;
  };

  //  try for browser tab close handle in ongoing call
  handleEndConcert = async () => {
    const data = {
      peer_id: this.state.current_call_peer_id
        ? this.state.current_call_peer_id
        : this.state.peer !== null
        ? this.state.peer._id
        : null,
      end_ts: moment().unix(),
      close_tab: true,
      project_id: this.projectId
    };
    let headers = {
      type: 'application/json',
      Authorization: `Bearer ${this.props.auth.authToken}`
    };
    let blob = new Blob([JSON.stringify(data)], headers);
    navigator.sendBeacon(`${APILINK}/user-calls/end-call-forcefully`, blob);
  };

  handleConnectionChange = () => {
    const condition = navigator.onLine ? 'online' : 'offline';
    if (condition === 'online') {
    } else {
      this.setState({ showDisconnected: true });
    }
  };

  handleClose() {
    this.setState({ showDisconnected: false }, () => this.closeRoom());
  }

  closeIpadDialog = () => {
    this.setState({ showPermissionDialog: false });
  };

  initializeGuestSocket = async (sessionToken) => {
    console.log(
      '👤 STAI2 - Creating socket for guest with sessionToken:',
      sessionToken?.substring(0, 10) + '...'
    );

    try {
      // Use static import
      const openSocket = io;

      console.log('🔗 STAI2 - Attempting guest socket connection to:', APILINK);
      this.socket = openSocket(APILINK, {
        forceNew: true,
        transports: ['websocket', 'polling'],
        timeout: 10000,
        query: {
          sessionToken: sessionToken,
          projectId: this.projectId,
          guestName: this.state.guestName || ''
        }
      });

      console.log('🔗 STAI2 - Guest socket connection initiated');

      // Setup guest socket events
      this.socket.on('connect', () => {
        console.log('✅ STAI2 - Guest socket connected, ID:', this.socket.id);

        // Initialize STAI2 connection for guest
        this.socket.emit('initialize-connection', {
          projectId: this.projectId
        });

        // Update state to show guest is waiting
        this.setState({
          current_state: CallStates.WAITING,
          isGuestWaiting: true
        });

        // Start listening for user events (for guest)
        this.listenToUserEvent();
      });

      this.socket.on('connect_error', (error) => {
        console.error('❌ STAI2 - Guest socket connection error:', error);
      });

      this.socket.on('disconnect', (reason) => {
        console.warn('🔴 STAI2 - Guest socket disconnected, reason:', reason);
      });

      this.socket.on('error', (error) => {
        console.error('❌ STAI2 - Guest socket error:', error);
      });

      return true;
    } catch (error) {
      console.error('❌ STAI2 - Failed to create guest socket:', error);
      return false;
    }
  };

  initializeSocketDirectly = async () => {
    console.log('🔌 STAI2 - Creating socket directly (not waiting for Layout)');

    // Check if we have auth token
    if (!this.props.auth || !this.props.auth.authToken) {
      console.error('❌ STAI2 - No auth token available for socket connection');
      return false;
    }

    try {
      // Use static import
      const openSocket = io;

      console.log(
        '🔗 STAI2 - Attempting to connect socket with token:',
        !!this.props.auth.authToken
      );

      const socketConnection = openSocket(APILINK, {
        forceNew: true,
        transports: ['websocket', 'polling'],
        query: {
          token: this.props.auth.authToken,
          projectId: this.projectId
        },
        timeout: 10000
      });

      console.log('🔗 STAI2 - Socket connection result:', !!socketConnection);

      // Wait for connection to be established
      await new Promise((resolve, reject) => {
        socketConnection.on('connect', () => {
          console.log('✅ STAI2 - Socket connected successfully!');
          // Save socket to instance and context
          this.socket = socketConnection;
          this.setState({ socket: socketConnection });
          resolve(true);
        });

        socketConnection.on('connect_error', (error) => {
          console.error('❌ STAI2 - Socket connection error:', error);
          reject(error);
        });

        // Timeout after 10 seconds
        setTimeout(() => {
          reject(new Error('Socket connection timeout'));
        }, 10000);
      });

      this.socket = socketConnection;
      this.initializeSTAI2Socket();
      return true;
    } catch (error) {
      console.error('❌ STAI2 - Socket connection error:', error);
      return false;
    }
  };

  componentDidUpdate(prevProps) {
    // STAI2 gestisce il socket autonomamente tramite initializeSocketDirectly o initializeGuestSocket
    // Non usa più il socket dal context di Layout
  }

  initializeSTAI2Socket = () => {
    if (!this.socket) {
      console.error('❌ STAI2 - Cannot initialize, socket is null');
      return;
    }

    // Initialize STAI2 connection
    this.socket.emit('initialize-connection', {
      projectId: this.projectId
    });

    // Set up socket listeners based on user type
    if (this.props.auth && this.props.auth.user) {
      if (this.props.auth.user.role === 'User') {
        this.listenToUserEvent();
      } else {
        this.listenToInterpreterEvent();
      }
    } else if (this.state.isGuest) {
      this.listenToUserEvent();
    }
  };

  componentWillUnmount() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);

    // Check if this is a premature unmount
    const componentAge = Date.now() - (this.componentMountTime || 0);

    if (componentAge < 2000) {
      // Less than 2 seconds
      // Premature unmount detected
    }

    this.setState({ transcribeAudio: false });

    document.body.classList.remove('aside-minimize');
    document.body.classList.remove('stai2-body-override');
    document.documentElement.classList.remove('stai2-body-override');

    // Clean up all intervals
    if (this.interval) {
      clearInterval(this.interval);
    }
    if (this.connectionInterval) {
      clearInterval(this.connectionInterval);
    }
    if (this.queueRefreshInterval) {
      clearInterval(this.queueRefreshInterval);
    }
    if (this.interpreterCheckInterval) {
      clearInterval(this.interpreterCheckInterval);
    }
    if (this.guestWaitTimeout) {
      clearTimeout(this.guestWaitTimeout);
    }

    // Safe socket emit with null check
    if (this.socket) {
      this.socket.emit('closedAbruptly', {
        peer_id: this.state.current_call_peer_id
          ? this.state.current_call_peer_id
          : this.state.peer !== null
          ? this.state.peer._id
          : null,
        end_ts: moment().unix(),
        project_id: this.projectId
      });
    }

    // Safe socket emit with null check
    if (this.socket) {
      this.socket.emit('destroyWaitingList');
      // this.socket.disconnect(() => ({ peer_id: this.state.peer._id }));
    }
    clearInterval(this.connectionInterval);

    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }

    // Only call endCall if component has been active for reasonable time
    // Reuse componentAge from above (already declared at line 615)
    if (componentAge > 3000) {
      // Only if component lived more than 3 seconds
      console.log('🔄 STAI2 - Normal componentWillUnmount, calling endCall');
      this.endCall();
    } else {
      console.warn('⚠️ STAI2 - Skipping endCall due to premature unmount');
      // Just do minimal cleanup without redirect
      if (this.socket) {
        this.socket.disconnect();
      }
    }
  }

  updateCallEndTime = async () => {
    // Skip for guests since they don't have auth for API calls
    if (this.state.isGuest) {
      console.log('🔄 STAI2 - Skipping updateCallEndTime for guest');
      return;
    }

    // Skip if no auth
    if (!this.props.auth || !this.props.auth.user) {
      console.log('🔄 STAI2 - Skipping updateCallEndTime (no auth)');
      return;
    }

    try {
      // For STAI2, we don't need to update end time during call
      // Skip this operation for STAI2 project
    } catch (error) {
      // Error handling for edge cases
    }
  };

  listenToInterpreterEvent = () => {
    // New STAI2-specific interpreter events according to documentation
    this.socket.on('stai2-interpreter-event', (data) => {
      console.log('📡 STAI2 - STAI2 interpreter event received:', data);

      switch (data.type) {
        case 'GUEST_AVAILABLE':
          console.log('📡 STAI2 - Guest available for call');
          const receiverName = data.guestName || 'Guest User';

          this.setState({
            current_call_peer_id: data.peer_id,
            videoCallToggle: true,
            from_user: null, // null for guest
            clientId: null, // null for guest
            sessionToken: data.sessionToken,
            guestName: data.guestName,
            receiverName: receiverName
          });

          this.inializeCallFromInterpreter(data);
          break;

        case 'END_GUEST_CALL':
          console.log('📡 STAI2 - Guest call ended');
          this.setState({ videoCallToggle: false });
          this.removeUnloadPrompt();
          this.gracefulCallEnd();
          break;

        case 'GUEST_PEER_DESTROY':
          console.log('📡 STAI2 - Guest peer destroyed');
          this.setState({ videoCallToggle: false });
          this.gracefulCallEnd();
          break;

        default:
          console.log('📡 STAI2 - Unknown STAI2 interpreter event:', data.type);
          break;
      }
    });

    // Fallback to original interpreter-event for compatibility
    this.socket.on('interpreter-event', (data) => {
      console.log('📡 STAI2 - Interpreter event received:', data);

      switch (data.type) {
        case 'USER_ALREADY_ON_CALL':
          console.log('📡 STAI2 - User already on call, serving next user');
          this.setState({ from_user: null }, () => {
            this.serveNextUser();
          });
          break;

        case 'USER_AVAILBALE': // Keep typo as per backend documentation
        case 'USER_AVAILABLE': // Also handle correct spelling
          console.log('📡 STAI2 - User available for call');
          console.log('📡 STAI2 - Event data:', data);

          // Determine receiver name (guest or registered user)
          const receiverName = data.senderData
            ? `${data.senderData.firstName} ${data.senderData.lastName}`
            : data.guestName || 'Guest User';

          console.log('📡 STAI2 - Starting call with:', receiverName);
          console.log('📡 STAI2 - Is guest call:', !data.user_id && !!data.sessionToken);

          // Set up call state
          this.setState({
            current_call_peer_id: data.peer_id,
            videoCallToggle: true,
            from_user: data.user_id || null,
            clientId: data.user_id || null,
            sessionToken: data.sessionToken || null, // For guests
            guestName: data.guestName || null, // For guests
            receiverName: receiverName
          });

          // Initialize call from interpreter side
          this.inializeCallFromInterpreter(data);
          break;

        case 'END_CALL':
          console.log('📡 STAI2 - Call ended');
          this.setState({ videoCallToggle: false });
          this.removeUnloadPrompt();
          this.gracefulCallEnd();
          break;

        case 'PEER_DESTROY':
          console.log('📡 STAI2 - Peer destroyed');
          this.setState({ videoCallToggle: false });
          this.gracefulCallEnd();
          break;

        case 'REQUEST_TOGGLE_TRANSCRIPTION':
          if (!this.state.disableTranscriptionAndMute && !this.state.transcribeAudio) {
            this.setState({ showModal: true });
          }
          break;
        default:
          console.log('📡 STAI2 - Unknown interpreter event type:', data.type);
          break;
      }
    });
  };

  listenToUserEvent = () => {
    // Essential event logging only
    this.socket.onAny((eventName, ...args) => {
      if (['user-event', 'interpreter-event', 'call-initiated'].includes(eventName)) {
        console.log(`📡 STAI2 - ${eventName}:`, args[0]);
      }
    });

    // STAI2 user/guest events according to backend documentation
    this.socket.on('user-event', async (data) => {
      console.log('📡 STAI2 - User event received:', data);

      switch (data.type) {
        case 'CALL_INITIATED':
          console.log('📡 STAI2 - Call initiated by interpreter with peer:', data.peer_id);

          if (
            this.state.current_state !== CallStates.CONNECTED &&
            this.state.current_state !== CallStates.STARTING_CALL
          ) {
            console.log('🎯 STAI2 - GUEST: Exiting waiting mode and starting call');

            // Clear intervals since call is starting
            if (this.interpreterCheckInterval) {
              clearInterval(this.interpreterCheckInterval);
            }
            if (this.guestWaitTimeout) {
              clearTimeout(this.guestWaitTimeout);
            }

            // ✅ Fetch existing STAI2 room (interpreter already created it)
            try {
              console.log('🏗️ STAI2 - Fetching room created by interpreter...');
              let roomId = null;

              // Retry up to 3 times with 500ms delay (room may not be ready yet)
              for (let attempt = 1; attempt <= 3 && !roomId; attempt++) {
                try {
                  const roomResponse = await getSTAI2RoomByPeer(data.peer_id);
                  if (roomResponse && roomResponse.data && roomResponse.data.room_id) {
                    roomId = roomResponse.data.room_id;
                  }
                } catch (e) {
                  console.log(`🔄 STAI2 - Room not ready yet (attempt ${attempt}/3)`);
                }
                if (!roomId && attempt < 3) {
                  await new Promise((r) => setTimeout(r, 500));
                }
              }

              // Fallback: create room if interpreter hasn't created it yet
              if (!roomId) {
                console.log('🏗️ STAI2 - Room not found, creating as fallback...');
                const roomData = {
                  peer_id: data.peer_id,
                  interpreter_id: data.from_user,
                  user_id: this.state.isGuest ? null : this.props.auth?.user?.id || null,
                  session_token: this.state.isGuest ? this.state.sessionToken : null,
                  guest_name: this.state.isGuest ? this.state.guestName : null,
                  project_id: this.projectId
                };
                const createResponse = await createSTAI2Room(roomData);
                roomId = createResponse.data.room_id;
              }

              console.log('✅ STAI2 - Room ready:', roomId);

              // Enable chat and save room ID
              this.setState({
                showChat: true,
                roomId: roomId
              });
            } catch (roomError) {
              console.warn('⚠️ STAI2 - Failed to get/create room for chat:', roomError);
              // Continue with call even if room creation fails
            }

            // Set up call state for guest/user - EXIT WAITING MODE
            this.setState(
              {
                current_state: CallStates.STARTING_CALL,
                current_call_peer_id: data.peer_id,
                from_user: data.from_user || null,
                interpreterId: data.from_user || null,
                videoCallToggle: true,
                isGuestWaiting: false, // Exit waiting mode
                receiverName: data.senderData
                  ? `${data.senderData.firstName} ${data.senderData.lastName}`
                  : 'Interprete'
              },
              () => {
                console.log('📞 STAI2 - GUEST: State updated, now initiating call to interpreter');

                // Per guest E utenti registrati: l'utente chiama l'interprete
                if ((this.state.isGuest || this.props.auth?.user?.role === 'User') && this.state.peer) {
                  const logPrefix = this.state.isGuest ? '👤 STAI2 - GUEST' : '👤 STAI2 - USER';
                  console.log(`${logPrefix}: Calling interpreter at peer ID:`, data.peer_id);

                  // Get our video/audio stream first
                  this.getVideoAudioStream()
                    .then((stream) => {
                      console.log(`${logPrefix}: Got local stream, calling interpreter`);
                      this.setState({ localStream: stream });

                      // Call the interpreter
                      const call = this.state.peer.call(data.peer_id, stream);

                      if (call) {
                        console.log(`${logPrefix}: Call initiated to interpreter, waiting for response`);

                        // Listen for the interpreter's stream
                        call.on('stream', (remoteStream) => {
                          console.log(`${logPrefix}: Received interpreter stream`);
                          this.setState({ current_state: CallStates.CONNECTED });

                          // Setup video elements
                          const localEle = document.getElementById('local-video-container');
                          this.createVideo(
                            localEle,
                            stream,
                            this.state.peer_id,
                            'local',
                            this.state.guestName || this.state.senderName || 'You'
                          );

                          const remoteEle = document.getElementById('remote-video-container');
                          this.createVideo(
                            remoteEle,
                            remoteStream,
                            data.peer_id,
                            'remote',
                            this.state.receiverName || 'Interprete'
                          );

                          this.addUnloadPrompt();

                          console.log(`✅ STAI2 - Video call successfully established!`);
                        });

                        // Handle call events
                        call.on('close', () => {
                          console.log(`${logPrefix}: Call closed by interpreter`);
                          this.gracefulCallEnd();
                        });
                      } else {
                        console.error(`❌ STAI2 - Failed to initiate call to interpreter`);
                      }
                    })
                    .catch((error) => {
                      console.error(`❌ STAI2 - Error getting media stream:`, error);
                      alert(
                        "Errore nell'accesso alla videocamera/microfono. Verifica le autorizzazioni del browser."
                      );
                    });
                } else {
                  // Fallback for other cases
                  this.inializeCallFromUser();
                }
              }
            );
          }
          break;

        case 'END_CALL':
          console.log('📡 STAI2 - Call ended by interpreter');
          this.setState({ videoCallToggle: false });
          this.removeUnloadPrompt();
          this.gracefulCallEnd();
          break;

        case 'PEER_DESTROY':
          console.log('📡 STAI2 - Peer destroyed');
          this.setState({ videoCallToggle: false });
          this.gracefulCallEnd();
          break;

        case 'TOGGLE_TRANSCRIPTION':
          this.setState({ transcribeAudio: data['transcribeAudio'] });
          break;

        default:
          console.log('📡 STAI2 - Unknown user event type:', data.type);
          break;
      }
    });

    // Listen for interpreter unavailable
    this.socket.on('interpreter-unavailable', (data) => {
      console.log('📡 STAI2 - Interpreter unavailable:', data.interpreterId);
      // For guests: Just log, no complex tracking needed
    });

    // 🔧 FALLBACK: Multiple event listeners for call initiation
    this.socket.on('interpreter-event', (data) => {
      console.log('📡 STAI2 - GUEST received interpreter-event:', data);

      if (data.type === 'CALL_INITIATED') {
        this.handleIncomingCall(data, 'interpreter-event');
      }
    });

    // 🔧 Additional fallback - listen for any call-related events
    this.socket.on('stai2-call-initiated', (data) => {
      console.log('📡 STAI2 - GUEST received stai2-call-initiated:', data);
      this.handleIncomingCall(data, 'stai2-call-initiated');
    });

    // 🔧 Fallback - listen for generic call events
    this.socket.on('call-started', (data) => {
      console.log('📡 STAI2 - GUEST received call-started:', data);
      this.handleIncomingCall(data, 'call-started');
    });

    // 🔧 Direct peer call detection
    if (this.state.peer) {
      this.state.peer.on('call', (call) => {
        console.log('📞 STAI2 - GUEST: Direct PeerJS call received!');
        this.handleDirectPeerCall(call);
      });
    }
  };

  // Helper function to handle incoming calls from any source
  handleIncomingCall = (data, source) => {
    console.log(`🎯 STAI2 - GUEST: Incoming call from ${source}:`, data);

    if (
      this.state.current_state === CallStates.CONNECTED ||
      this.state.current_state === CallStates.STARTING_CALL
    ) {
      console.log('📞 STAI2 - GUEST: Already in call, ignoring');
      return;
    }

    // Clear interpreter checking interval since call is starting
    if (this.interpreterCheckInterval) {
      clearInterval(this.interpreterCheckInterval);
    }

    // Set up call state
    this.setState(
      {
        current_state: CallStates.STARTING_CALL,
        current_call_peer_id: data.peer_id,
        from_user: data.from_user || data.interpreter_id || null,
        interpreterId: data.from_user || data.interpreter_id || null,
        videoCallToggle: true,
        isGuestWaiting: false,
        receiverName: data.senderData
          ? `${data.senderData.firstName} ${data.senderData.lastName}`
          : 'Interprete'
      },
      () => {
        console.log('📞 STAI2 - GUEST: Starting call initialization');
        this.inializeCallFromUser();
      }
    );
  };

  // Handle direct PeerJS call
  handleDirectPeerCall = (call) => {
    console.log('📞 STAI2 - GUEST: Handling direct PeerJS call from peer:', call.peer);
    this.handleIncomingPeerCall(call);
  };

  // Handle incoming PeerJS call for guests
  handleIncomingPeerCall = (call) => {
    console.log('📞 STAI2 - GUEST: Processing incoming PeerJS call from:', call.peer);

    this.setState({
      current_state: CallStates.STARTING_CALL,
      videoCallToggle: true,
      isGuestWaiting: false,
      current_call_peer_id: call.peer
    });

    // Get user's video/audio stream and answer the call
    this.getVideoAudioStream()
      .then((stream) => {
        console.log('📞 STAI2 - GUEST: Got local stream, answering call');
        this.setState({ localStream: stream });

        // Answer the call with our stream
        call.answer(stream);

        // Listen for remote stream
        call.on('stream', (remoteStream) => {
          console.log('📞 STAI2 - GUEST: Received remote stream from interpreter');
          this.setState({ current_state: CallStates.CONNECTED });

          // Setup local video
          const localEle = document.getElementById('local-video-container');
          this.createVideo(
            localEle,
            stream,
            this.state.peer_id,
            'local',
            this.state.guestName || 'You'
          );

          // Setup remote video
          const remoteEle = document.getElementById('remote-video-container');
          this.createVideo(
            remoteEle,
            remoteStream,
            call.peer,
            'remote',
            this.state.receiverName || 'Interprete'
          );

          // Add unload prompt and start call timer
          this.addUnloadPrompt();
          //this.interval = setInterval(this.updateCallEndTime, 300000);

          console.log('✅ STAI2 - GUEST: Video call successfully established!');
        });

        // Handle call end
        call.on('close', () => {
          console.log('📞 STAI2 - GUEST: Call closed by interpreter');
          this.gracefulCallEnd();
        });
      })
      .catch((error) => {
        console.error('❌ STAI2 - GUEST: Error getting media stream:', error);
        alert(
          "Errore nell'accesso alla videocamera/microfono. Verifica le autorizzazioni del browser."
        );
      });
  };

  checkInterpreterAvailability = async () => {
    // For guests: Use API to check if interpreters are in waiting room
    if (this.state.isGuest) {
      try {
        console.log('👤 STAI2 - Guest: Checking interpreters via API');

        const result = await checkInterpretersAvailable(this.state.sessionToken, this.projectId);

        console.log('👤 STAI2 - Interpreter check result:', result);

        this.setState({
          interpreter_available: result.count,
          waiting_users: result.queuePosition
        });
      } catch (error) {
        console.warn('👤 STAI2 - Error checking interpreters:', error);
        // Continue normally if API fails
      }
    }
  };

  checkForWaitingUsers = async () => {
    // Only interpreters should check for waiting users
    if (!this.props.auth || !this.props.auth.user || this.props.auth.user.role !== 'Interpreter') {
      return; // Guests don't need to check anything
    }

    try {
      const temp_count = await getWaitingUserCount(this.projectId);

      // Handle response structure
      let userCount = [];
      let interpreterCount = [];

      if (temp_count?.data) {
        userCount = temp_count.data.user_count || [];
        interpreterCount = temp_count.data.interpreter_count || [];
      } else if (temp_count?.user_count !== undefined) {
        userCount = temp_count.user_count || [];
        interpreterCount = temp_count.interpreter_count || [];
      } else if (Array.isArray(temp_count)) {
        userCount = temp_count;
      }

      const temp_state = {
        waiting_users: Array.isArray(userCount) ? userCount : [],
        interpreter_available: Array.isArray(interpreterCount) ? interpreterCount : []
      };

      // Check if we should show "Serve Next User" button
      if (
        temp_state.waiting_users.length > 0 &&
        this.props.auth.user.role === 'Interpreter' &&
        !this.state.videoCallToggle
      ) {
        temp_state['current_state'] = CallStates.READY_TO_ACCEPT;
      } else {
        if (
          this.state.current_state !== CallStates.CONNECTED &&
          this.state.current_state !== CallStates.STARTING_CALL
        ) {
          temp_state['current_state'] = CallStates.WAITING;
        }
      }

      this.setState({ ...temp_state });
    } catch (error) {
      console.error('❌ STAI2 - Error in checkForWaitingUsers:', error);
      alert('Si è verificato un errore. Ricarica la pagina per riprovare.');
    }
  };

  initializePeerConnection = () => {
    console.log(Math.floor(100000 + Math.random() * 900000));

    const options = {
      host: HOST,
      secure: true,
      debug: 3,
      config: {
        iceServers: ICESERVERS
      }
    };

    if (process.env.NODE_ENV === 'production') {
      options.port = 9000;
    }

    return new Peer(`${Math.floor(100000 + Math.random() * 900000)}`, options);
  };

  initializePeersEvents = () => {
    this.state.peer.on('open', (id) => {
      //console.log('peer opened', this.state.peer);
      this.setState({ peer_id: id, current_state: CallStates.WAITING });

      // Socket connection already initialized in componentDidMount
      console.log('🔗 STAI2 - Peer initialized with ID:', id);
    });

    // 🔧 IMPORTANT: Add call listener for incoming calls (especially for guests)
    this.state.peer.on('call', (call) => {
      console.log('📞 STAI2 - PEER: Incoming call received from:', call.peer);

      if (this.state.isGuest) {
        console.log('👤 STAI2 - GUEST: Processing incoming peer call via peer event listener');
        this.handleIncomingPeerCall(call);
      } else {
        // For registered users, use existing logic but avoid duplicate handling
        console.log('👤 STAI2 - REGISTERED USER: Processing incoming peer call');
        this.handleIncomingPeerCall(call);
      }
    });

    this.state.peer.on('error', () => {
      this.state.peer.reconnect();
    });
    this.state.peer.on('disconnected', () => {
      //console.log('disconnected');
    });

    this.state.peer.on('close', () => {
      //console.log('peer closed', this.state.peer);
      this.setState({ peer: null });
      if (this.socket) {
        this.socket.emit('peer-destroyed', { user_id: this.state.from_user });
      }
    });
  };

  inializeCallFromInterpreter = (availableUserData = null) => {
    this.getVideoAudioStream().then(
      (stream) => {
        if (this.state.peer) {
          this.setState({ localStream: stream });
          console.log('call started');
          const temp_call = this.state.peer.call(this.state.current_call_peer_id, stream);
          // change to set peer id
          this.props.videoCallActions.setPeerId(this.state.current_call_peer_id);
          if (temp_call) {
            // create user call record using STAI2 API
            if (availableUserData) {
              const data = {
                peer_id: availableUserData['peer_id'],
                interpreter_id: this.props.auth.user.id,
                user_id: availableUserData['user_id'] || null,
                sessionToken: availableUserData['sessionToken'] || this.state.sessionToken,
                guestName: availableUserData['guestName'] || this.state.guestName,
                projectId: this.projectId
              };

              // NOTE: UserCall is created by the create-room HTTP endpoint.
              // No separate initializeSTAI2Call/initializeSTAI2GuestCall needed.
              console.log('📡 STAI2 - Call data prepared (UserCall created via create-room):', data);

              this.state.showChat = true;
            }
            // end
            temp_call.on('stream', (remoteStream) => {
              this.setState({
                current_state: CallStates.CONNECTED,
                alertShow: true
              });

              const local_ele = document.getElementById('local-video-container');
              this.createVideo(
                local_ele,
                stream,
                this.state.peer_id,
                'local',
                this.state.senderName
              );
              const remote_ele = document.getElementById('remote-video-container');
              this.createVideo(
                remote_ele,
                remoteStream,
                this.state.current_call_peer_id,
                'remote',
                this.state.receiverName
              );
              //this.interval = setInterval(this.updateCallEndTime, 300000);
              this.addUnloadPrompt();
            });
          }
        }
      },
      function(err) {
        console.log('Failed to get local stream', err);
      }
    );
  };

  inializeCallFromUser = () => {
    // Handle incoming data connections
    this.state.peer.on('call', (call) => {
      this.state.showChat = true;
      this.getVideoAudioStream().then((stream) => {
        this.setState({ localStream: stream });
        call.answer(stream);
        call.on(
          'stream',
          (remoteStream) => {
            this.setState({
              current_state: CallStates.CONNECTED
            });

            // Show stream in some video/canvas element.
            const local_ele = document.getElementById('local-video-container');
            this.createVideo(local_ele, stream, this.state.peer_id, 'local', this.state.senderName);
            const remote_ele = document.getElementById('remote-video-container');
            this.createVideo(
              remote_ele,
              remoteStream,
              this.state.current_call_peer_id,
              'remote',
              this.state.receiverName
            );
            this.addUnloadPrompt();
          },
          function(err) {
            console.log('Failed to get local stream', err);
          }
        );
      });
    });
  };

  // ✅ FIXED: Optimized for iOS Safari
  getVideoAudioStream = (video = true, audio = true) => {
    // Piu' handler possono chiedere lo stream per la stessa chiamata (peer.on('call')
    // e' registrato piu' volte). Memoizziamo la promise: tutti ricevono LO STESSO stream
    // reale invece che undefined, e getUserMedia viene invocato una volta sola.
    // Il memo viene azzerato a fine chiamata da destoryConnection().
    if (!this.mediaStreamPromise) {
      this.mediaStreamPromise = this.requestVideoAudioStream(video, audio).catch((error) => {
        this.mediaStreamPromise = null; // fallito: la prossima chiamata puo' riprovare
        throw error;
      });
    }
    return this.mediaStreamPromise;
  };

  requestVideoAudioStream = async (video = true, audio = true) => {
    // 🔧 iOS Specific: Simplify constraints to avoid OverconstrainedError
    // Safari on iOS hates complex constraints (max/min/aspectRatio) unless perfect
    const isIOS = this.state.isIOS || this.state.isSafari;

    let videoConstraints = video;

    if (video) {
      if (isIOS) {
        videoConstraints = {
          facingMode: 'user', // Default to front camera
          width: { ideal: 640 }, // Keep it simple for iOS
          height: { ideal: 480 }
        };
      } else {
        videoConstraints = {
          width: { min: 640, ideal: 1280, max: 1280 },
          height: { min: 480, ideal: 720, max: 720 },
          frameRate: { ideal: 15, max: 30 },
          facingMode: 'user'
        };
      }
    }

    const constraints = {
      video: videoConstraints,
      audio: audio
        ? {
            echoCancellation: true,
            noiseSuppression: true,
            autoGainControl: true
          }
        : false
    };

    const getUserMedia =
      navigator.mediaDevices?.getUserMedia ||
      navigator.webkitGetUserMedia ||
      navigator.mozGetUserMedia ||
      navigator.msGetUserMedia;

    if (!getUserMedia) {
      return Promise.reject(new Error('getUserMedia not supported'));
    }

    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      return navigator.mediaDevices.getUserMedia(constraints).catch((error) => {
        console.error('Error accessing media devices:', error);

        // 🔧 iOS Fallback: If HD fails, try absolute minimum constraints
        if (isIOS && video) {
          console.log('📱 STAI2 - Retrying with minimal video constraints for iOS');
          return navigator.mediaDevices.getUserMedia({
            video: { width: 320, height: 240 }, // Very basic
            audio: audio
          });
        }
        throw error;
      });
    } else {
      return new Promise((resolve, reject) => {
        getUserMedia.call(navigator, constraints, resolve, reject);
      });
    }
  };

  // ✅ FIXED: Optimized for iOS Video Elements
  createVideo = (element, stream, id, type, name) => {
    if (!this.state.videoContainer[id]) {
      const temp_video_container = this.state.videoContainer;
      temp_video_container[id] = { id: id, stream: stream, type };
      this.setState({ videoContainer: temp_video_container });
      const video = document.createElement('video');

      // 🔧 IOS FIX: Set attributes BEFORE source
      video.setAttribute('playsinline', 'true'); // Critical for iOS inline playback
      video.setAttribute('webkit-playsinline', 'true'); // Old iOS support
      video.setAttribute('autoplay', 'true');

      // 🔧 IOS FIX: Mute local video to prevent feedback loop and allow autoplay
      // Remote video might need user interaction to unmute on iOS if not handled by system
      if (type === 'local') {
        video.muted = true;
      }

      video.id = this.state.peer_id === id ? this.state.peer_id : id; // Fix ID assignment logic
      video.width = 600;
      video.height = 300;

      // Assign stream
      video.srcObject = stream;

      if (this.state.isSafari || this.state.isIOS) {
        video.style.objectFit = 'cover';
      }

      if (type !== 'local') {
        const para = document.createElement('p');
        para.innerText = `${name}`;
        para.style.color = 'white';
        para.style.fontWeight = '600';
        para.style.textTransform = 'uppercase';
        para.style.marginBottom = '5px';
        para.style.textAlign = 'center';
        para.style.position = 'absolute';
        para.style.top = '10px';
        para.style.zIndex = '100';
        para.style.marginRight = 'auto';
        para.style.marginLeft = 'auto';
        para.style.left = '0';
        para.style.right = '0';

        para.id = `p_${this.state.peer_id === id ? this.state.peer_id : id}`;
        //element.appendChild(para); // Removed for privacy
      }
      element.appendChild(video);

      // 🔧 IOS FIX: Robust play handling
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch((error) => {
          console.warn('Auto-play failed (expected on iOS without interaction):', error);
          // If auto-play fails, mute and try again (iOS allows muted autoplay)
          if (!video.muted) {
            video.muted = true;
            video.play().catch((e) => console.error('Even muted autoplay failed', e));
          }
          // Add touch listener to allow user to start video manually if needed
          video.addEventListener(
            'touchstart',
            () => {
              video.play();
              if (type !== 'local') video.muted = false; // Unmute remote on touch
            },
            { once: true }
          );
        });
      }
    }
  };

  removeVideo = (id) => {
    const temp_video_container = this.state.videoContainer;
    delete temp_video_container[id];
    const video = document.getElementById(id);
    const para = document.getElementById(`p_${id}`);
    if (video) video.remove();
    if (para) para.remove();
    this.setState({
      videoContainer: temp_video_container
    });
  };

  onMute = () => {
    Object.keys(this.state.videoContainer).forEach((vid) => {
      if (this.state.videoContainer[vid]['type'] === 'local') {
        const audioTracks = this.state.videoContainer[vid].stream.getAudioTracks();
        if (audioTracks.length > 0) {
          audioTracks[0].enabled = !this.state.audioEnabled;
        }
      }
    });
    this.setState({ audioEnabled: !this.state.audioEnabled });
  };

  toggleTranscription = () => {
    const newTranscriptionState = !this.state.transcribeAudio;
    this.setState({ transcribeAudio: newTranscriptionState });

    if (this.socket) {
      this.socket.emit('toggle-transcription', {
        userId: this.state.from_user,
        sessionToken: this.state.sessionToken,
        transcribe: newTranscriptionState,
        projectId: this.projectId
      });
    }
  };

  closeRoom = async () => {
    console.log('🚪 STAI2 - Close room called');

    // Clean up intervals
    if (this.interpreterCheckInterval) {
      clearInterval(this.interpreterCheckInterval);
    }

    if (this.state.isGuest) {
      console.log('👤 STAI2 - Guest leaving, cleaning up');

      // Leave queue if guest is still in queue
      if (this.state.sessionToken) {
        try {
          await leaveQueue(this.state.sessionToken);
          console.log('✅ STAI2 - Guest left queue successfully');
        } catch (error) {
          console.error('❌ STAI2 - Error leaving queue:', error);
        }

        // Clear session token
        localStorage.removeItem('stai2SessionToken');
        localStorage.removeItem('stai2CallData');
      }

      // Disconnect socket
      if (this.socket) {
        this.socket.disconnect();
      }

      // Go back to project selection or home
      window.location.href = '/guest?id=' + this.projectId + '&h=1';
    } else if (this.props.auth && this.props.auth.user) {
      // Authenticated users go to dashboard
      if (this.props.auth.user.role === 'Interpreter') {
        console.log('🔄 STAI2 - Interpreter closing room, redirecting to dashboard');
        this.props.history.push('/Interpreter/dashboard');
      } else {
        this.props.history.push('/dashboard');
      }
    } else {
      // Fallback to home
      window.location.href = '/';
    }
  };

  serveNextUser = async () => {
    console.log('⏱️ STAI2 - serveNextUser delay completed');
    console.log('🔧 STAI2 - serveNextUser called');
    try {
      // ✅ Use the new fixed endpoint - backend resolved 500 error
      console.log('📡 STAI2 - Using NEW FIXED endpoint: get-waiting-users');
      const waitingUsersResponse = await getWaitingUsers(this.projectId);
      console.log('📡 STAI2 - Got waiting users response:', waitingUsersResponse);

      let waitingUsers = [];

      // Handle response structure from new endpoint
      if (Array.isArray(waitingUsersResponse)) {
        waitingUsers = waitingUsersResponse;
      } else if (waitingUsersResponse.data && Array.isArray(waitingUsersResponse.data)) {
        waitingUsers = waitingUsersResponse.data;
      }

      if (waitingUsers.length === 0) {
        console.log('📡 STAI2 - No users waiting in queue');
        return;
      }

      // Get first user from queue
      const userData = waitingUsers[0];
      console.log('📡 STAI2 - Serving first user:', userData);

      // Determina il nome da mostrare: utente registrato (Account) o guest
      const displayName = userData.Account
        ? `${userData.Account.firstName} ${userData.Account.lastName}`.trim()
        : (userData.guest_name || 'Utente');

      // Emit STAI2 socket event to initialize call
      if (this.socket) {
        const socketData = {
          user_id: userData.userId || null, // null for guest users
          sessionToken: userData.session_token || null, // session token for guest
          peer_id: this.state.peer_id,
          guestName: displayName,
          interpreter_id: this.props.auth.user.id, // Add interpreter ID
          projectId: this.projectId // STAI2
        };

        console.log('📡 STAI2 - Socket emit data:', socketData);
        this.socket.emit('initialize-call', socketData);

        console.log('🔄 STAI2 - Socket event sent, backend will handle via socket events');

        // ✅ Create STAI2 room for chat and whiteboard
        try {
          console.log('🏗️ STAI2 - Creating room for chat/whiteboard...');
          const roomData = {
            peer_id: this.state.peer_id,
            interpreter_id: this.props.auth.user.id,
            user_id: userData.userId || null, // null for guest users
            session_token: userData.session_token || null, // for guest users
            guest_name: userData.guest_name || null, // for guest users
            project_id: this.projectId // STAI2
          };

          const roomResponse = await createSTAI2Room(roomData);
          const roomId = roomResponse.data.room_id;

          console.log('✅ STAI2 - Room created successfully:', roomId);

          // Enable chat and save room ID
          this.setState({
            showChat: true,
            roomId: roomId
          });
        } catch (roomError) {
          console.warn('⚠️ STAI2 - Failed to create room for chat:', roomError);
          // Continue with call even if room creation fails
        }

        // 🔧 INTERPRETER: Prepare to receive call from guest
        console.log('📞 STAI2 - INTERPRETER: Socket event sent, now waiting for guest to call us');

        // The guest will receive the user-event and call us
        // We just need to be ready to accept the call
      } else {
        console.error('❌ STAI2 - Socket is null, cannot emit initialize-stai2-call');
      }

      // Update local state for call
      this.setState({
        current_state: CallStates.STARTING_CALL,
        from_user: userData.userId || null,
        sessionToken: userData.session_token || null,
        guestName: displayName,
        receiverName: displayName,
        current_call_peer_id: userData.guest_peer_id || 'waiting-for-guest-peer'
      });

      // Refresh queue count after accepting user
      const temp_count = await getWaitingUserCount(this.projectId);
      let responseData = temp_count;
      if (temp_count && temp_count.data) {
        responseData = temp_count.data;
      }

      this.setState({
        waiting_users:
          responseData && responseData.user_count && responseData.user_count.length > 0
            ? responseData.user_count
            : []
      });

      console.log('✅ STAI2 - User served, call initiated');

      // 🔗 FALLBACK: Generate direct guest access URL for manual testing
      if (userData && userData.session_token && userData.guest_name) {
        const guestCallUrl = `${window.location.origin}/guest-call?peer_id=${
          this.state.peer_id
        }&sessionToken=${userData.session_token}&guestName=${encodeURIComponent(
          userData.guest_name
        )}`;
        console.log('🔗 STAI2 - Guest can manually navigate to:', guestCallUrl);
        console.log('🔗 STAI2 - Or use this in new tab for testing');
      }

      setTimeout(() => {
        if (!this.state.videoCallToggle) {
          this.setState({ current_state: CallStates.WAITING });
        }
      }, 10000);
    } catch (error) {
      console.error('❌ STAI2 - Error in serveNextUser:', error);
      alert('Si è verificato un errore. Ricarica la pagina per riprovare.');
    }
  };

  endCall = () => {
    console.log('🔄 STAI2 - End call initiated, isGuest:', this.state.isGuest);

    // Protection: Don't end call if component just mounted (likely premature unmount due to error)
    const componentAge = Date.now() - (this.componentMountTime || 0);
    if (componentAge < 3000) {
      // Less than 3 seconds
      console.warn('⚠️ STAI2 - Preventing premature endCall, component age:', componentAge + 'ms');
      return;
    }

    this.setState({ transcribeAudio: false });
    this.removeUnloadPrompt();

    // Only authenticated users can call API endpoints
    if (this.props.auth && this.props.auth.user && !this.state.isGuest) {
      console.log('🔄 STAI2 - Authenticated user ending call via API');
      const endData = {
        peer_id: this.state.peer_id,
        end_ts: moment().unix(),
        close_tab: true,
        project_id: this.projectId
      };

      // Import service dynamically to avoid import issues
      import('./stai2Service').then((module) => {
        module
          .endSTAI2Call(endData)
          .catch((err) => console.error('❌ STAI2 - End call API error:', err));
      });
    } else if (this.state.isGuest) {
      console.log('🔄 STAI2 - Guest ending call (no API call needed)');
      // Guests don't need to call API endpoints
    }

    // Emit socket event to end call
    if (this.socket) {
      this.socket.emit('end-call', {
        user_id: this.state.from_user || (this.state.isGuest ? 'guest' : null),
        projectId: this.projectId // STAI2
      });
    }

    this.gracefulCallEnd();
  };

  destoryConnection = () => {
    // Libera il memo cosi' una chiamata successiva nella stessa tab riottiene la camera
    this.mediaStreamPromise = null;
    try {
      if (this.state.videoContainer && typeof this.state.videoContainer === 'object') {
        Object.keys(this.state.videoContainer).forEach((vid) => {
          try {
            const container = this.state.videoContainer[vid];
            if (container && container.stream && typeof container.stream.getTracks === 'function') {
              const myMediaTracks = container.stream.getTracks();
              myMediaTracks.forEach((track) => {
                if (track && typeof track.stop === 'function') {
                  track.stop();
                }
              });
            }
          } catch (error) {
            console.warn('⚠️ STAI2 - Error stopping track for video:', vid, error);
          }
        });
      }
    } catch (error) {
      console.warn('⚠️ STAI2 - Error in destoryConnection:', error);
    }
  };

  gracefulCallEnd = async () => {
    console.log('🔄 STAI2 - Graceful call end started');

    // Protection: Don't redirect if component just mounted (likely premature end)
    const componentAge = Date.now() - (this.componentMountTime || 0);
    if (componentAge < 5000) {
      // Less than 5 seconds
      console.warn(
        '⚠️ STAI2 - Preventing premature gracefulCallEnd redirect, component age:',
        componentAge + 'ms'
      );
      console.warn(
        '⚠️ STAI2 - This might indicate an initialization error. Just doing cleanup without redirect.'
      );

      // Do minimal cleanup without redirect
      this.destoryConnection();
      if (this.state.peer) {
        try {
          this.state.peer.disconnect();
          this.state.peer.destroy();
        } catch (error) {
          console.warn('⚠️ STAI2 - Error destroying peer:', error);
        }
      }
      return; // Exit early without redirect
    }

    // Safe DOM manipulation with null check
    try {
      const ktContent = document.getElementById('kt_content');
      if (ktContent && ktContent.classList) {
        ktContent.classList.remove('black-color');
      }
    } catch (error) {
      console.warn('🔄 STAI2 - Error removing black-color class:', error);
    }

    this.state.peer_id && this.removeVideo(this.state.peer_id);
    this.state.current_call_peer_id && this.removeVideo(this.state.current_call_peer_id);
    this.destoryConnection();

    // End call using STAI2 endpoints - only for authenticated users
    if (
      this.state.current_call_peer_id &&
      this.props.auth &&
      this.props.auth.user &&
      !this.state.isGuest
    ) {
      try {
        console.log(
          '🔄 STAI2 - Authenticated user ending call with peer:',
          this.state.current_call_peer_id
        );

        const endData = {
          peer_id: this.state.peer_id,
          end_ts: moment().unix(),
          project_id: this.projectId
        };

        await endSTAI2Call(endData);

        console.log('✅ STAI2 - Call ended successfully');
      } catch (error) {
        console.warn('⚠️ STAI2 - Error ending call (may be expected):', error);
        // Don't throw error, continue with cleanup
      }
    } else if (this.state.isGuest) {
      console.log('🔄 STAI2 - Guest call end (no API call needed)');
    }

    // Clean up peer connection
    if (this.state.peer) {
      try {
        this.state.peer.disconnect();
        this.state.peer.destroy();
      } catch (error) {
        console.warn('⚠️ STAI2 - Error destroying peer:', error);
      }
    }

    // Handle different user types
    if (this.state.isGuest || !this.props.auth || !this.props.auth.user) {
      // Guest users - redirect to guest access page
      console.log('🔄 STAI2 - Guest call ended, redirecting to guest access');
      this.setState({
        current_state: CallStates.CALL_ENDED,
        current_call_peer_id: null,
        peer_id: null,
        peer: null,
        from_user: null,
        isFullScreen: false,
        audioEnabled: true
      });
      if (this.project && this.project.rating) {
        this.setState({ showRatingPopup: true });
      } else {
        window.location.href = window.location.origin + '/guest?id=' + this.projectId + '&h=1';
      }
    } else if (this.props.auth.user.role === 'User') {
      // Authenticated regular users
      console.log('🔄 STAI2 - User call ended, redirecting to dashboard');
      this.setState({
        current_state: CallStates.WAITING,
        current_call_peer_id: null,
        peer_id: null,
        peer: null,
        from_user: null,
        isFullScreen: false,
        audioEnabled: true
      });
      window.location.href = window.location.origin + '/dashboard';
    } else if (this.props.auth.user.role === 'Interpreter') {
      // Interpreters - For STAI2, skip motive modal and go directly to dashboard
      console.log(
        '🔄 STAI2 - Interpreter call ended, going to dashboard (no motive modal for STAI2)'
      );
      this.setState({
        current_state: CallStates.WAITING,
        current_call_peer_id: null,
        peer_id: null,
        peer: null,
        from_user: null,
        isFullScreen: false,
        audioEnabled: true
      });
      window.location.reload();
      //window.location.href = window.location.origin + '/Interpreter/dashboard';
    }
  };

  onChangeScreen = () => {
    this.setState({ isFullScreen: !this.state.isFullScreen });
  };

  submitFunctionForInterpreterMotive = async (values) => {
    // console.log(values);
    // console.log(this.state);
    // values.peer_id = this.state.current_call_peer_id;

    values.peer_id = this.state.current_call_peer_id;
    this.props.videoCallActions.setPeerId(null);
    const res = await setReasonOfCall(values);
    if (res.data) {
      this.setState(
        {
          current_state: CallStates.WAITING,
          current_call_peer_id: null,
          peer_id: null,
          peer: null,
          from_user: null,
          isFullScreen: false,
          audioEnabled: true
        },
        async () => {
          window.location.reload();
        }
      );
    } else {
      this.setState(
        {
          current_state: CallStates.WAITING,
          current_call_peer_id: null,
          peer_id: null,
          peer: null,
          from_user: null,
          isFullScreen: false,
          audioEnabled: true
        },
        async () => {
          alert('reason is not store in database');
          window.location.reload();
        }
      );
    }
  };

  handleToggleRequest = () => {
    this.socket.emit('request-toggle-transcription', {
      userId: this.state.from_user,
      projectId: this.projectId
    });
  };

  handleConfirmToggle = () => {
    this.setState({ showModal: false });
    this.toggleTranscription();
  };

  handleRatingSubmit = async (rating) => {
    console.log('⭐ STAI2 - Rating submitted:', rating);

    // Salva il rating chiamando l'endpoint /save-rating
    try {
      const { saveRating } = await import('./stai2Service');
      await saveRating({
        rating,
        sessionToken: this.state.sessionToken,
        projectId: this.projectId,
        peerId: this.state.peer_id,
        isGuest: this.state.isGuest
      });
      console.log('⭐ STAI2 - Rating saved successfully');
    } catch (error) {
      console.error('❌ STAI2 - Error saving rating:', error);
    }

    // Chiudi il popup del rating e mostra il popup di ringraziamento
    this.setState({ showRatingPopup: false, showThankYouPopup: true });

    // Dopo 2 secondi, chiudi il popup e fai il redirect
    setTimeout(() => {
      this.setState({ showThankYouPopup: false });
      window.location.href = window.location.origin + '/guest?id=' + this.projectId + '&h=1';
    }, 2000);
  };

  handleRatingSkip = () => {
    console.log('⭐ STAI2 - Rating skipped');
    window.location.href = window.location.origin + '/guest?id=' + this.projectId + '&h=1';
  };

  render() {
    let validationSchema = Yup.object().shape({
      title: Yup.string().required(
        this.props.intl.formatMessage({
          id: 'AUTH.VALIDATION.REQUIRED_FIELD'
        })
      )
    });

    // Safe DOM manipulation with null checks
    const ktContent = document.getElementById('kt_content');
    if (ktContent) {
      if (this.state.current_state !== CallStates.CONNECTED) {
        ktContent.classList.remove('black-color');
      } else {
        ktContent.classList.add('black-color');
      }
    }

    // Applica lo sfondo grigio scuro al body e HTML
    document.body.classList.add('stai2-body-override');
    document.documentElement.classList.add('stai2-body-override');

    // Nome del partecipante remoto mostrato nella barra superiore:
    // l'interprete vede il nome dell'ospite, l'ospite vede l'interprete.
    const remoteParticipantName = isInterpreter()
      ? this.state.guestName || this.state.receiverName || ''
      : !this.state.receiverName || this.state.receiverName === 'Interpreter'
      ? 'Interprete'
      : this.state.receiverName;

    return (
      <>
        <Prompt when={false} message={() => 'Sei Sicuro di voler lasciare la videochiamata?'} />
        <ConfirmationDialog
          open={this.state.showPermissionDialog}
          title="Richiesta di autorizzazione"
          content="È necessario confermare l'autorizzazione per ricevere notifiche acustiche all'arrivo di un utente."
          onClose={this.closeIpadDialog}
        />
        {/* iOS Specific Permission Dialog */}
        {this.state.isIOS && (
          <Modal
            show={this.state.openDialog}
            onHide={() => this.setState({ openDialog: false })}
            dialogClassName="modal-dialog-centered"
          >
            <Modal.Header>
              <h5>Autorizzazioni necessarie</h5>
            </Modal.Header>
            <Modal.Body>
              <p>Per utilizzare la videochiamata su iPhone/iPad, è necessario:</p>
              <ul>
                <li>Consentire l'accesso alla fotocamera</li>
                <li>Consentire l'accesso al microfono</li>
                <li>Toccare "Consenti" quando richiesto dal browser</li>
              </ul>
              <p>
                <strong>Nota:</strong> Potrebbe essere necessario toccare il video per avviare la
                riproduzione se non si avvia automaticamente.
              </p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="primary" onClick={() => this.setState({ openDialog: false })}>
                Ho capito
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        <div id="full-screen-wrap"></div>

        <div className="d-flex flex-row no-gutters stai2-video-call-wrapper">
          {this.state.showBlackboard && (
            <div className="col-md-9 col-12 blackboard-div">
              {/* Pulsante chiudi blackboard mobile */}
              <button
                className="mobile-blackboard-close-btn"
                onClick={this.handleBlackboard}
                aria-label="Chiudi lavagna"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
                <span>Torna alla videochiamata</span>
              </button>
              <TldrawBoard show={this.state.showBlackboard} roomId={this.state.roomId} />
            </div>
          )}
          <div
            className={`${
              this.state.current_state !== CallStates.CONNECTED
                ? ''
                : this.state.showBlackboard
                ? 'col-md-3 col-12'
                : 'col-md-8'
            }`}
            style={{
              flex: this.state.current_state !== CallStates.CONNECTED ? 1 : null
            }}
          >
            {console.log('🔧 STAI2 - Rendering video call, state:', this.props)}
            {this.state.current_state !== CallStates.CONNECTED ? (
              <>
                {this.props.auth &&
                this.props.auth.user &&
                this.props.auth.user.role === 'Interpreter' ? (
                  <CallComponent
                    serveNextUser={this.serveNextUser}
                    closeRoom={this.closeRoom}
                    current_state={this.state.current_state}
                    waiting={this.state.waiting_users}
                  />
                ) : (
                  <UserCallComponent
                    waiting={this.state.waiting_users}
                    interpreter_available={this.state.interpreter_available}
                    current_state={this.state.current_state}
                    closeRoom={this.closeRoom}
                  />
                )}
              </>
            ) : (
              <div
                className={`video-call-main has-stai2-topbar ${
                  this.state.showMobileChat || this.state.showBlackboard
                    ? 'mobile-blackboard-active'
                    : ''
                }`}
                style={{
                  // Posizione personalizzata per il video flottante su mobile (chat o blackboard)
                  ...((this.state.showMobileChat || this.state.showBlackboard) &&
                    this.state.floatingVideoPosition.x !== null && {
                      top: `${this.state.floatingVideoPosition.y}px`,
                      left: `${this.state.floatingVideoPosition.x}px`,
                      right: 'auto',
                      transition: this.state.isDraggingVideo ? 'none' : 'all 0.1s ease'
                    })
                }}
                onTouchStart={this.handleVideoTouchStart}
                onTouchMove={this.handleVideoTouchMove}
                onTouchEnd={this.handleVideoTouchEnd}
              >
                {/* iOS Video Fix Warning */}
                {this.state.isIOS && (
                  <div className="ios-video-warning">
                    Se il video non si avvia, tocca l'area video
                  </div>
                )}{' '}
                <div
                  className={`video-call-box ${this.state.isFullScreen ? 'fs' : ''} ${
                    this.state.showBlackboard ? 'video-call-box-blackboard' : ''
                  } ${this.state.showMobileChat ? 'mobile-chat-active' : ''}`}
                  style={{
                    // iOS specific video container optimizations
                    ...(this.state.isIOS && {
                      webkitTransform: 'translateZ(0)',
                      transform: 'translateZ(0)',
                      backfaceVisibility: 'hidden',
                      perspective: '1000px'
                    })
                  }}
                >
                  <div
                    id="local-video-container"
                    className="local-video-container mr-4"
                    style={{
                      // iOS local video optimizations
                      ...(this.state.isIOS && {
                        webkitTransform: 'translate3d(0,0,0)',
                        transform: 'translate3d(0,0,0)',
                        webkitBackfaceVisibility: 'hidden',
                        backfaceVisibility: 'hidden'
                      })
                    }}
                  ></div>
                  {/* Barra superiore: partecipante, durata chiamata, schermo intero */}
                  <CallTopBar
                    participantName={remoteParticipantName}
                    durationRunning={this.state.current_state === CallStates.CONNECTED}
                    isFullScreen={this.state.isFullScreen}
                    onToggleFullScreen={this.onChangeScreen}
                    compact={this.state.showBlackboard || this.state.showMobileChat}
                  />

                  <div
                    id="remote-video-container"
                    className=""
                    style={{
                      position: 'relative',
                      // iOS video container optimizations
                      ...(this.state.isIOS && {
                        webkitTransform: 'translate3d(0,0,0)',
                        transform: 'translate3d(0,0,0)',
                        webkitBackfaceVisibility: 'hidden',
                        backfaceVisibility: 'hidden'
                      })
                    }}
                  >
                    {' '}
                    {!this.state.showMobileChat &&
                      this.state.isFullScreen &&
                      this.state.transcribeAudio && (
                        <VideoCallTranscriptions
                          stream={this.state.localStream}
                          audioEnabled={this.state.audioEnabled}
                          transcribeAudio={this.state.transcribeAudio}
                          isFullScreen={true}
                          isUser={!isInterpreter()}
                          clientId={this.state.clientId}
                          interpreterId={this.state.interpreterId}
                          userId={this.state.userId}
                          socket={this.socket}
                          sessionToken={this.state.sessionToken}
                        />
                      )}
                  </div>

                  <div className="end-video-call-container">
                    <span className="end-call" onClick={this.endCall}>
                      <svg
                        height="512"
                        viewBox="0 0 128 128"
                        width="512"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g id="Circle_Grid" data-name="Circle Grid">
                          <circle cx="64" cy="64" fill="#ef5261" r="64" />
                        </g>
                        <g id="icon">
                          <path
                            d="m57.831 70.1c8.79 8.79 17.405 12.356 20.508 9.253l4.261-4.26a7.516 7.516 0 0 1 10.629 0l9.566 9.566a7.516 7.516 0 0 1 0 10.629l-7.453 7.453c-7.042 7.042-27.87-2.358-47.832-22.319-9.976-9.981-16.519-19.382-20.748-28.222s-5.086-16.091-1.567-19.61l7.453-7.453a7.516 7.516 0 0 1 10.629 0l9.566 9.563a7.516 7.516 0 0 1 0 10.629l-4.264 4.271c-3.103 3.1.462 11.714 9.252 20.5z"
                            fill="#eeefee"
                          />
                        </g>
                      </svg>
                    </span>
                    <span className="mute" onClick={this.onMute}>
                      {!this.state.audioEnabled ? (
                        <img
                          alt="mute"
                          src={toAbsoluteUrl('/media/svg/icons/Call/mute-microphone.svg')}
                        />
                      ) : (
                        <img
                          alt="un-mute"
                          src={toAbsoluteUrl('/media/svg/icons/Call/microphone.svg')}
                        />
                      )}
                    </span>
                    {!isInterpreter() &&
                      !this.state.disableTranscriptionAndMute &&
                      !this.state.transcribeAudio && (
                        <span className="request-transcription" onClick={this.handleToggleRequest}>
                          <img
                            alt="transcription"
                            src={toAbsoluteUrl('/media/svg/icons/Call/request-transcription.svg')}
                          />
                        </span>
                      )}
                    {isInterpreter() && !this.state.disableTranscriptionAndMute && (
                      <span className="transcription-span" onClick={this.toggleTranscription}>
                        {!this.state.transcribeAudio ? (
                          <img
                            alt="enable-transcription"
                            src={toAbsoluteUrl('/media/svg/icons/Call/end-transcription.svg')}
                          />
                        ) : (
                          <img
                            alt="end-transcription"
                            src={toAbsoluteUrl('/media/svg/icons/Call/transcription.svg')}
                          />
                        )}
                      </span>
                    )}
                    <span className="blackboard" onClick={this.handleBlackboard}>
                      <img
                        alt="Blackboard"
                        src={toAbsoluteUrl('/media/svg/icons/Design/PenAndRuller.svg')}
                      />
                    </span>
                    <span
                      className={`mobile-chat-toggle ${this.state.showMobileChat ? 'active' : ''}`}
                      onClick={this.toggleMobileChat}
                    >
                      <img
                        alt="Chat"
                        src={toAbsoluteUrl('/media/svg/icons/Communication/Chat6.svg')}
                      />
                    </span>
                  </div>
                </div>
                <div
                  className={`video-call-list ${this.state.isFullScreen ? 'fs' : ''} ${
                    this.state.showBlackboard ? 'display-none' : ' '
                  }`}
                >
                  {this.props.auth &&
                    this.props.auth.user &&
                    this.props.auth.user.role === 'Interpreter' && (
                      <ul>
                        {this.state.waiting_users &&
                          this.state.waiting_users.length > 0 &&
                          this.state.waiting_users.map((e, index) => {
                            if (e.account) {
                              return (
                                <>
                                  <li key={index}>
                                    <p className="mb-0">
                                      {e.account.firstName}
                                      {'  '}
                                      {e.account.lastName}
                                    </p>
                                    <small>{moment(e.createdAt).fromNow()}</small>
                                  </li>
                                </>
                              );
                            } else {
                              return '';
                            }
                          })}
                      </ul>
                    )}
                </div>
                {!this.state.showMobileChat &&
                  this.state.showChat &&
                  !this.state.isFullScreen &&
                  this.state.transcribeAudio && (
                    <VideoCallTranscriptions
                      stream={this.state.localStream}
                      audioEnabled={this.state.audioEnabled}
                      transcribeAudio={this.state.transcribeAudio}
                      isFullScreen={false}
                      isUser={!isInterpreter()}
                      clientId={this.state.clientId}
                      interpreterId={this.state.interpreterId}
                      userId={this.state.userId}
                      socket={this.socket}
                      sessionToken={this.state.sessionToken}
                    />
                  )}
              </div>
            )}
          </div>
          {this.state.current_state === CallStates.CONNECTED &&
            this.socket &&
            this.socket.connected &&
            this.state.showChat && (
              <div
                className={`col-md-4 col-12 stai2-chat-panel ${
                  this.state.showBlackboard ? 'display-none' : ''
                } ${this.state.showMobileChat ? 'mobile-chat-visible' : ''}`}
              >
                {/* Pulsante chiudi chat mobile */}
                <button
                  className="mobile-chat-close-btn"
                  onClick={this.toggleMobileChat}
                  aria-label="Chiudi chat"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                  <span>Torna alla videochiamata</span>
                </button>
                <Suspense
                  fallback={
                    <div
                      style={{
                        padding: '20px',
                        textAlign: 'center',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      Loading STAI2 chat...
                    </div>
                  }
                >
                  <STAI2VideoRoomList
                    props={{
                      peer_id: this.state.isGuest
                        ? this.state.current_call_peer_id
                        : this.state.peer_id,
                      roomId: this.state.roomId, // ✅ Pass roomId directly
                      showChat: this.state.showChat
                    }}
                    socket={this.socket}
                    projectId={this.projectId}
                    sessionToken={this.state.sessionToken} // For guest users
                    guestName={this.state.guestName} // For guest display
                    callData={{
                      sessionToken: this.state.sessionToken,
                      isGuest: this.state.isGuest || false,
                      guestName: this.state.guestName
                    }}
                  />
                </Suspense>
              </div>
            )}
        </div>
        <Modal
          show={this.state.showDisconnected}
          onHide={() => this.handleClose()}
          dialogClassName="modal-dialog-centered"
        >
          <Modal.Body>
            <p>Connessione Persa!</p>
            <p>Errore di connessione</p>
            <div className="text-right">
              <Button variant="primary" onClick={() => this.handleClose()}>
                OK
              </Button>
            </div>
          </Modal.Body>
        </Modal>
        <TranscriptionModal
          show={this.state.showModal}
          onHide={() => this.setState({ showModal: false })}
          onConfirm={this.handleConfirmToggle}
        />
        <Modal
          show={this.state.interpreter_motive_modal}
          // toggle={(e) => props.setToggle(!props.toggle)}
          dialogClassName="modal-dialog-centered"
        >
          <Modal.Header>
            <h3>Motivo della chiamata</h3>
          </Modal.Header>

          <Formik
            enableReinitialize={true}
            initialValues={this.state.interpreter_motive_modal_initial_values}
            validationSchema={validationSchema}
            onSubmit={(value) => this.submitFunctionForInterpreterMotive(value)}
          >
            {({ errors, touched, setFieldValue, values }) => (
              <Form>
                <Modal.Body>
                  <div className="form-group row">
                    <div className="col-lg-12">
                      <label className="col-form-label">Indica il motivo della chiamata</label>
                      <Select
                        options={titleOptions}
                        name="title"
                        value={titleOptions.filter((data) => data.value === values.title)}
                        className={`form-control form-control-solid h-auto py-5 px-6`}
                        onChange={(e) => setFieldValue(`title`, e.value)}
                      />
                      {touched.title && errors.title ? (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">{errors.title}</div>
                        </div>
                      ) : null}
                    </div>
                    <div className="col-lg-12">
                      <label className="col-form-label">Note</label>
                      <textarea
                        placeholder="Note"
                        rows="4"
                        className={`form-control form-control-solid h-auto py-5 px-6`}
                        name="note"
                        value={values.note}
                        onChange={(e) => setFieldValue('note', e.target.value)}
                      />

                      {touched.note && errors.note ? (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">{errors.note}</div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <button
                    type="submit"
                    className="btn btn-primary m-0"
                    disabled={this.state.buttonEventDisable}
                  >
                    Salva
                  </button>
                </Modal.Footer>
              </Form>
            )}
          </Formik>
        </Modal>

        {/* Rating Popup */}
        <RatingPopup
          show={this.state.showRatingPopup}
          onClose={this.handleRatingSkip}
          onSubmit={this.handleRatingSubmit}
          userName={this.state.receiverName || this.state.guestName || "l'utente"}
        />

        {/* Thank You Popup */}
        <Modal
          show={this.state.showThankYouPopup}
          centered
          backdrop="static"
          keyboard={false}
          dialogClassName="modal-dialog-centered"
        >
          <Modal.Body className="text-center py-5">
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>🙏</div>
            <h4>Grazie per averci dato la tua opinione!</h4>
          </Modal.Body>
        </Modal>

        {/* iOS Specific CSS and Responsive Styles */}
        <style jsx>{`
          @media screen and (-webkit-min-device-pixel-ratio: 2) {
            .video-call-box video {
              -webkit-transform: translateZ(0);
              transform: translateZ(0);
              -webkit-backface-visibility: hidden;
              backface-visibility: hidden;
              -webkit-perspective: 1000px;
              perspective: 1000px;
            }
          }

          /* iOS Safari specific fixes */
          video::-webkit-media-controls-start-playback-button {
            display: none !important;
            -webkit-appearance: none;
          }

          video {
            -webkit-playsinline: true;
            -webkit-transform: translateZ(0);
            transform: translateZ(0);
            margin-bottom: -5px !important;
          }

          .ios-video-warning {
            animation: fadeInOut 3s ease-in-out infinite;
          }

          @keyframes fadeInOut {
            0%,
            100% {
              opacity: 0.7;
            }
            50% {
              opacity: 1;
            }
          }

          /* Mobile responsive styles */
          @media (max-width: 768px) {
            .stai2-chat-panel {
              flex: 1 !important;
              height: 40vh !important;
              min-height: 250px !important;
            }

            .blackboard-div {
              height: 100vh !important;
              width: 100% !important;
            }
          }

          @media (max-width: 480px) {
            .stai2-chat-panel {
              height: 45vh !important;
            }
          }

          /* Landscape mobile */
          @media (max-width: 768px) and (orientation: landscape) {
            .stai2-chat-panel {
              display: none !important;
            }
          }
        `}</style>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth
});

const mapDispatchToEvents = (dispatch) => {
  return {
    videoCallActions: bindActionCreators(videoCall.actions, dispatch)
  };
};

export default injectIntl(connect(mapStateToProps, mapDispatchToEvents)(VideoCallPage));
